module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-4.a972e9d8.jpeg";